/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AddressCreatedRequest } from './address-created-request';
/**
 * 
 * @export
 * @interface ShippingInfo
 */
export interface ShippingInfo {
  _id?: string;
    /**
     * 
     * @type {AddressCreatedRequest}
     * @memberof ShippingInfo
     */
    addressFrom: AddressCreatedRequest;
    /**
     * 
     * @type {AddressCreatedRequest}
     * @memberof ShippingInfo
     */
    addressTo: AddressCreatedRequest;
    /**
     * 
     * @type {Date}
     * @memberof ShippingInfo
     */
    objectCreated: Date;
    /**
     * 
     * @type {string}
     * @memberof ShippingInfo
     */
    objectId: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingInfo
     */
    objectOwner: string;
    /**
     * 
     * @type {Date}
     * @memberof ShippingInfo
     */
    objectUpdated: Date;
    /**
     * 
     * @type {string}
     * @memberof ShippingInfo
     */
    status: ShippingInfoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingInfo
     */
    test: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShippingInfo
     */
    metadata: string;
}

/**
    * @export
    * @enum {string}
    */
export enum ShippingInfoStatusEnum {
    ERROR = 'ERROR',
    QUEUED = 'QUEUED',
    SUCCESS = 'SUCCESS',
    WAITING = 'WAITING'
}

